var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhyChooseIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Group_141418",
    "data-name": "Group 141418",
    width: 28.891,
    height: 26.563,
    viewBox: "0 0 28.891 26.563",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_119172",
    "data-name": "Path 119172",
    d: "M20297.844,7298.14s-1.725-9.608,3.336-11.19,8.9-2.071,10.285-4.372c.217.63,2.711,7.779-5.215,10.291s-8.406,5.271-8.406,5.271",
    transform: "translate(-20283.115 -7282.578)",
    fill: "#073c00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_119173",
    "data-name": "Path 119173",
    d: "M20311.723,7298.14s1.725-9.608-3.336-11.19-8.9-2.071-10.285-4.372c-.217.63-2.711,7.779,5.215,10.291s8.406,5.271,8.406,5.271",
    transform: "translate(-20297.561 -7271.578)",
    fill: "#073c00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyChooseIcon3);
export default __webpack_public_path__ + "static/media/whyChoose-icon3.3ab0c7e2dd1c7dc503f947a6614b8b9e.svg";
export { ForwardRef as ReactComponent };